(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      if (!this.header) return;

      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.preventHide = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
      this.scheduleAnnouncementBarOffset = this.scheduleAnnouncementBarOffset.bind(this);
      this.handleAnnouncementBarSectionChange = this.handleAnnouncementBarSectionChange.bind(this);
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => {
        this.preventReveal = true;
      };

      this.setHeaderHeight();
      this.observeAnnouncementBars();
      window.addEventListener('resize', this.setHeaderHeight);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.setHeaderHeight);
      window.removeEventListener('resize', this.scheduleAnnouncementBarOffset);
      document.removeEventListener('shopify:section:load', this.handleAnnouncementBarSectionChange);
      document.removeEventListener('shopify:section:unload', this.handleAnnouncementBarSectionChange);

      if (this.announcementBarResizeObserver) {
        this.announcementBarResizeObserver.disconnect();
        this.announcementBarResizeObserver = null;
      }

      if (this.announcementOffsetFrame) {
        cancelAnimationFrame(this.announcementOffsetFrame);
      }
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', String(this.header.offsetHeight) + 'px');
    }

    observeAnnouncementBars() {
      if (typeof ResizeObserver !== 'undefined' && !this.announcementBarResizeObserver) {
        this.announcementBarResizeObserver = new ResizeObserver(this.scheduleAnnouncementBarOffset);
      }

      document.querySelectorAll('.announcement-bar-section').forEach((announcementBar) => {
        if (this.announcementBarResizeObserver) {
          this.announcementBarResizeObserver.observe(announcementBar);
        }
      });

      if (!this.announcementBarListenersBound) {
        window.addEventListener('resize', this.scheduleAnnouncementBarOffset);
        document.addEventListener('shopify:section:load', this.handleAnnouncementBarSectionChange);
        document.addEventListener('shopify:section:unload', this.handleAnnouncementBarSectionChange);
        this.announcementBarListenersBound = true;
      }

      this.scheduleAnnouncementBarOffset();
    }

    handleAnnouncementBarSectionChange() {
      this.observeAnnouncementBars();
    }

    scheduleAnnouncementBarOffset() {
      if (this.announcementOffsetFrame) {
        cancelAnimationFrame(this.announcementOffsetFrame);
      }

      this.announcementOffsetFrame = requestAnimationFrame(() => {
        const totalHeight = Array.from(document.querySelectorAll('.announcement-bar-section')).reduce((height, announcementBar) => {
          const styles = window.getComputedStyle(announcementBar);
          const isVisible = styles.display !== 'none' && styles.visibility !== 'hidden' && announcementBar.getClientRects().length > 0;
          return isVisible ? height + announcementBar.getBoundingClientRect().height : height;
        }, 0);

        document.documentElement.style.setProperty('--announcement-bars-height', String(Math.ceil(totalHeight)) + 'px');
      });
    }

    createObserver() {
      const observer = new IntersectionObserver((entries, currentObserver) => {
        if (entries[0]) {
          this.headerBounds = entries[0].intersectionRect;
        }
        currentObserver.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  } catch(e) { console.error(e); }
})();
})();
